var map = {
	"./objects-01.svg": 18,
	"./objects-02.svg": 105,
	"./objects-03.svg": 240,
	"./objects-04.svg": 47,
	"./objects-05.svg": 510,
	"./objects-06.svg": 645,
	"./objects-07.svg": 924,
	"./objects-08.svg": 467,
	"./objects-09.svg": 474,
	"./objects-10.svg": 800,
	"./objects-11.svg": 721,
	"./objects-12.svg": 970,
	"./objects-13.svg": 163,
	"./objects-14.svg": 748,
	"./objects-15.svg": 733,
	"./objects-16.svg": 486,
	"./objects-17.svg": 607,
	"./objects-18.svg": 688,
	"./objects-19.svg": 281,
	"./objects-20.svg": 353,
	"./objects-21.svg": 816,
	"./objects-22.svg": 859,
	"./objects-23.svg": 218,
	"./objects-24.svg": 149,
	"./objects-25.svg": 676,
	"./objects-26.svg": 703,
	"./objects-27.svg": 974,
	"./objects-28.svg": 497,
	"./objects-29.svg": 104
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 165;